/**
 * Правая сворачиваемая панель общего поиска кадастров на главной карте.
 * Форма остаётся смонтированной при collapse, чтобы не сбрасывать query/результаты.
 */
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { CadastreExternalSearchForm } from "@/components/CadastreExternalSearchForm";
import { cn } from "@/lib/utils";

export interface CadastreSearchPanelProps {
  collapsed: boolean;
  onCollapsedChange: (collapsed: boolean) => void;
  onClose: () => void;
}

export function CadastreSearchPanel({
  collapsed,
  onCollapsedChange,
  onClose,
}: CadastreSearchPanelProps) {
  return (
    <div
      className={cn(
        "flex border-l bg-background/95 shrink-0",
        collapsed ? "w-10 flex-col items-center py-2 gap-2" : "w-80 flex-col gap-3 p-3 overflow-y-auto",
      )}
    >
      {collapsed ? (
        <>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="h-8 w-8"
            onClick={() => onCollapsedChange(false)}
            aria-label="Развернуть панель поиска кадастров"
            title="Развернуть"
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="h-8 w-8"
            onClick={onClose}
            aria-label="Закрыть панель поиска кадастров"
            title="Закрыть"
          >
            <X className="h-4 w-4" />
          </Button>
          <div
            className="text-xs text-muted-foreground mt-2 select-none"
            style={{ writingMode: "vertical-rl" }}
          >
            Поиск кадастров
          </div>
        </>
      ) : (
        <div className="flex items-center justify-between gap-2">
          <div className="font-medium">Поиск кадастров</div>
          <div className="flex items-center gap-0.5">
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="h-8 w-8"
              onClick={() => onCollapsedChange(true)}
              aria-label="Свернуть панель поиска кадастров"
              title="Свернуть"
            >
              <ChevronRight className="h-4 w-4" />
            </Button>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="h-8 w-8"
              onClick={onClose}
              aria-label="Закрыть панель поиска кадастров"
              title="Закрыть"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      )}

      <div className={cn(collapsed && "hidden")}>
        <CadastreExternalSearchForm compact />
      </div>
    </div>
  );
}
